import { CourseType, CoursewareResourceType } from "../enum";

// 一级权限icon
export const ConfigIcon = {
  首页: "indexPage",
  内容管理: "contentManage",
  合作反馈: "cooperateFeedback",
  政企用户: "enterprise",
  高校用户: "college",
  招聘中心: "recruitCenter",
  合作伙伴: "cooperatePartner",
  公开招标: "feedback",
  管理员管理: "adminManage",
  内容审核: "compliance"
};

export const STORAGE_CONFIG = {
  LOGIN_USER: "userInfo",
  TOKEN: "accessToken",
  GROUP_ID: "groupId",
  APPLICATION_KEY: "applicationKey",
  LOGIN_EXPIRE: "loginExpire",
  LOGIN_DATE: "loginDate",
  AUTO_LOGIN: "autoLogin",
  REFRESH_TOKEN: "refreshToken",
  CLASS_INFO: "classInfo",
  USER_PERMISSIONS: "userPermissions",
  ICT_GROUP_ID: "groupId",
  ICT_USER_INFO: "userInfo"
};

export const FILE_CHUNK_SIZE = 1024 * 1024; // 1M

export const CourseStatusMap = {
  0: "删除",
  1: "已发布",
  2: "未发布"
};

export const CourseTypeMap = {
  [CourseType.special]: "专业课",
  [CourseType.live]: "直播课"
};

export const CourseWareMap = {
  0: "未知类型",
  [CoursewareResourceType.video]: "视频",
  [CoursewareResourceType.ppt]: "PPT",
  [CoursewareResourceType.pdf]: "PDF"
};

export const PageSizeOption = ["10", "20", "30", "50", "100"];
export const PageShowTotalFn = total => `共${total}条数据`;

export const LayoutToName = {
  1: "MP4",
  2: "AVI",
  3: "PDF",
  4: "MD",
  5: "ZIP",
  6: "RAR",
  7: "JAR",
  8: "7Z"
};
export const LayoutToNameList = [
  {
    key: "",
    value: "全部"
  },
  {
    key: "3",
    value: "PDF"
  },
  {
    key: "5",
    value: "ZIP"
  },
  {
    key: "6",
    value: "RAR"
  },
  {
    key: "7",
    value: "JAR"
  },
  {
    key: "8",
    value: "7Z"
  }
];
export const AboutMenuList = [
  {
    title: "平台介绍",
    name: "Introduction",
    path: "introduction"
  },
  {
    title: "联系我们",
    name: "Contact",
    path: "contact"
  },
  // {
  //   title: "用户协议",
  //   name: "UserAgreement",
  //   path: "user-agreement",
  // },
  {
    title: "服务协议",
    name: "ServerAgreement",
    path: "server-agreement"
  },
  {
    title: "隐私政策",
    name: "PrivacyAgreement",
    path: "privacy-agreement"
  },
  {
    title: "常见问题",
    name: "FAQ",
    path: "FAQ"
  }
];

export const MaterialType = [
  { label: "实验配套文档", key: "1", enName: "LabDocument" },
  { label: "工具软件", key: "2", enName: "toolsSoftware" },
  { label: "技术手册", key: "3", enName: "technicalManual" },
  { label: "烧写文件", key: "4", enName: "BurnWriteFiles" },
  {
    label: "实验原理图",
    key: "5",
    enName: "ExperimentalPrototypeDiagram"
  },
  { label: "实验PCB图", key: "6", enName: "LabPCB" },
  { label: "例程代码包", key: "7", enName: "RoutineCodePackage" }
];

export const NUMBER = [
  "零",
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
  "十一",
  "十二",
  "十三",
  "十四",
  "十五",
  "十六",
  "十七",
  "十八",
  "十九",
  "二十"
];
// 实训云
export const SXY_APPLICATION_KEY = "1331ec8b-3d40-4d9e-9c33-77a8760fe617";
export const SXY_CLASS_TYPE = "706749786450997348";
// ICT
export const ICT_APPLICATION_KEY = "1881ec8b-3d40-4d9e-9c33-77a8760fe618";
export const ICT_CLASS_TYPE = "902596110779486222";
